import { useRouter } from 'next/router';

// Utils
import useUser from '@/utils/hooks/swr/useUser';

// Lib
import { GIVEAWAY_PICKER, GIVEAWAY_PICKER_RESULTS } from '@/lib/routes/publicRoutes';

import { AdobeExpress } from '@/components/tools/AdobeExpress';
import { DataDogErrorMonitoring } from '@/components/tools/DataDogErrorMonitoring';
import { DataDogLogCollection } from '@/components/tools/DataDogLogCollection';
import DeleteOldCookies from '@/components/tools/DeleteOldCookies';
import { FlagsmithUserIdentifier } from '@/components/tools/FlagsmithUserIdentifier';
// Scripts
import GoogleTagManager from '@/components/tools/GoogleTagManager';
import HubSpotIdentification from '@/components/tools/HubSpotIdentification';
import { IsUserLoggedIn } from '@/components/tools/IsUserLoggedIn';
import { MixPanelInitialize } from '@/components/tools/MixPanel/MixPanelInitialize';

const Tools = () => {
    const router = useRouter();
    const { user } = useUser({ revalidateOnMount: false });

    if (router.pathname === GIVEAWAY_PICKER || router.pathname === GIVEAWAY_PICKER_RESULTS) {
        return (
            <>
                <DataDogErrorMonitoring />
                <DataDogLogCollection />
            </>
        );
    }

    return (
        <>
            <GoogleTagManager />
            <DataDogErrorMonitoring />
            <DataDogLogCollection />
            <AdobeExpress />
            {user ? <MixPanelInitialize /> : null}
            <IsUserLoggedIn />
            <FlagsmithUserIdentifier />
            {/* This is a custom script to delete old cookies from user's browsers => remove this after a while : https://iconosquare.atlassian.net/browse/ICO-2059*/}
            <DeleteOldCookies />
            <HubSpotIdentification />
        </>
    );
};

export default Tools;
